import { DateTime, Interval } from "luxon";

class DayPartHelper {
  constructor(props, offset) {
    this.eventOptions = props.eventDefinition.event;
    this.repeatOptions = props.eventDefinition.repeat;
    this._offset = offset;
  }

  get beginDateTime() {
    // SP-1863: if all day is selected we don't get a time value, assume starts at midnight of start day.
    return DateTime.fromFormat(
      `${this.eventOptions.beginningDate} ${this.eventOptions.beginningTime || "00:00:00"}`,
      "yyyy-MM-dd HH:mm:ss"
    );
  }

  get endDateTime() {
    return this._beginEndDaysInterval === 0 ? this._repetitionEndDate : DateTime.min(this._eventEndDate, this._repetitionEndDate);
  }

  get _beginEndDaysInterval() {
    return Math.floor(this._eventEndDate.diff(this.beginDateTime, ["days"]).toObject().days);
  }

  get _eventEndDate() {
    // SP-1863: if all day is selected we don't get a time value, assume full day to midnight of end day.
    return DateTime.fromFormat(`${this.eventOptions.endDate} ${this.eventOptions.endTime || "23:59:00"}`, "yyyy-MM-dd HH:mm:ss");
  }

  get _repetitionEndDate() {
    if (!this.repeatOptions) {
      return this._eventEndDate;
    }

    if (!this.repeatOptions.end) {
      return DateTime.fromMillis(1e15);
    }

    if (this.repeatOptions.end.count) {
      const offsetPeriod = this.repeatOptions.interval * this.repeatOptions.end.count;
      return DateTime.fromFormat(this.eventOptions.beginningDate, "yyyy-MM-dd")
        .plus({ [this._offset]: offsetPeriod })
        .plus({ minutes: 1 });
    }

    return DateTime.fromISO(this.repeatOptions.end.datetime);
  }

  isAllDay() {
    return (
      this.eventOptions.allDay || (this.eventOptions.beginningTime === "00:00:00" && this.eventOptions.endTime === "00:00:00")
    );
  }

  repeatsAlways() {
    return !this.repeatOptions || this.repeatOptions.interval === 1;
  }

  matchesPeriod(now) {
    const diffPeriod = now.diff(this.beginDateTime, [this._offset]).toObject()[this._offset];
    return Math.floor(diffPeriod) % this.repeatOptions.interval === 0;
  }

  matchesTimeFrame(now) {
    let beginTime = DateTime.fromFormat(`${now.toISODate()} ${this.eventOptions.beginningTime}`, "yyyy-MM-dd HH:mm:ss");
    let endTime = DateTime.fromFormat(`${now.toISODate()} ${this.eventOptions.endTime}`, "yyyy-MM-dd HH:mm:ss");

    if (beginTime > endTime) {
      if (now < endTime) {
        beginTime = DateTime.fromISO(beginTime).minus({ days: 1 });
      }
      if (now > beginTime) {
        endTime = DateTime.fromISO(endTime).plus({ days: 1 });
      }
    }

    return Interval.fromDateTimes(beginTime, endTime).contains(DateTime.fromISO(now));
  }
}

export default DayPartHelper;
